/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CompressorForecastState,
  CompressorForecastState$inboundSchema,
} from "./compressorforecaststate.js";

/**
 * A single point-in-time in the MPC compressor schedule forecast
 */
export type CompressorScheduleStep = {
  /**
   * State per compressor, same order as the compressors array
   */
  states: Array<CompressorForecastState>;
  /**
   * RFC3339 formatted time in UTC
   */
  timestamp: Date;
};

/** @internal */
export const CompressorScheduleStep$inboundSchema: z.ZodType<
  CompressorScheduleStep,
  z.ZodTypeDef,
  unknown
> = z.object({
  states: z.array(CompressorForecastState$inboundSchema),
  timestamp: types.date(),
});

export function compressorScheduleStepFromJSON(
  jsonString: string,
): SafeParseResult<CompressorScheduleStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompressorScheduleStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompressorScheduleStep' from JSON`,
  );
}
